/* ============================================================
   MINDWISE — custom-product.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }
  function progressInRange(v, a, b) { return b === a ? (v >= b ? 1 : 0) : clamp((v - a) / (b - a), 0, 1); }
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  function updatePinState(section, stickyEl) {
    if (!section || !stickyEl) return;
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight;
    if (rect.top > 0) {
      stickyEl.classList.remove('is-pinned', 'is-after');
    } else if (rect.bottom <= vh) {
      stickyEl.classList.remove('is-pinned');
      stickyEl.classList.add('is-after');
    } else {
      stickyEl.classList.remove('is-after');
      stickyEl.classList.add('is-pinned');
    }
  }

  function initBacopaFill() {
    var section = document.querySelector('.mw-bacopa-intro');
    if (!section) return;
    var stickyEl = section.querySelector('.mw-bacopa-intro__sticky');
    var fillWords = section.querySelectorAll('.mw-fill-text');
    var plantGray = section.querySelector('[data-plant-img-gray]');
    var plantGreen = section.querySelector('[data-plant-img-green]');

    var wordThresholds = [[0, 0.5], [0.35, 0.85]];   // "Bacopa" then "is created equal"

    var ticking = false;
    function update() {
      ticking = false;
      updatePinState(section, stickyEl);

      var rect = section.getBoundingClientRect();
      var scrollable = section.offsetHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var scrolled = clamp(-rect.top, 0, scrollable);
      var progress = scrolled / scrollable;

      fillWords.forEach(function (el, i) {
        var range = wordThresholds[i] || [0, 1];
        var local = easeOutCubic(progressInRange(progress, range[0], range[1]));
        el.style.setProperty('--fill-pos', (100 - local * 100) + '%');
      });

      // Gray base plant grows bottom-to-top
      if (plantGray) {
        var stemLocal = easeOutCubic(progress);
        plantGray.style.setProperty('--stem', (stemLocal * 100) + '%');
      }

      // Green overlay: flowers bloom in sequence — left, then right, then middle/top
      if (plantGreen) {
        var leftLocal  = easeOutCubic(progressInRange(progress, 0, 0.4));
        var rightLocal = easeOutCubic(progressInRange(progress, 0.3, 0.7));
        var midLocal   = easeOutCubic(progressInRange(progress, 0.55, 0.95));

        plantGreen.style.setProperty('--r-left-x',  (leftLocal * 12) + '%');
        plantGreen.style.setProperty('--r-left-y',  (leftLocal * 17) + '%');
        plantGreen.style.setProperty('--r-right-x', (rightLocal * 12) + '%');
        plantGreen.style.setProperty('--r-right-y', (rightLocal * 17) + '%');
        plantGreen.style.setProperty('--r-mid-x',   (midLocal * 12) + '%');
        plantGreen.style.setProperty('--r-mid-y',   (midLocal * 17) + '%');
      }
    }

    function requestTick() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick);
    update();
  }

function initCdriReveal() {
    var section = document.querySelector('.mw-cdri-intro');
    if (!section) return;
    var stickyEl = section.querySelector('.mw-cdri-intro__sticky');
    var green = section.querySelector('[data-cdri-green]');
    var black = section.querySelector('[data-cdri-black]');
    var copy = section.querySelector('[data-cdri-copy]');
    var carousel = document.querySelector('.mw-cdri-carousel');

    var hasSnapped = false; // ek hi baar auto-scroll ho, baar-baar na ho

    var ticking = false;
    function update() {
      ticking = false;
      updatePinState(section, stickyEl);

      var rect = section.getBoundingClientRect();
      var scrollable = section.offsetHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var scrolled = clamp(-rect.top, 0, scrollable);
      var progress = scrolled / scrollable;

   var greenP = easeOutCubic(progressInRange(progress, 0, 0.28));
var blackP = easeOutCubic(progressInRange(progress, 0.24, 0.45));
var copyP = easeOutCubic(progressInRange(progress, 0.4, 0.58));

var fadeOutP = easeOutCubic(progressInRange(progress, 0.97, 1.0));
      if (stickyEl) {
        stickyEl.style.opacity = 1 - fadeOutP;
      }

      if (green) { green.style.opacity = greenP; green.style.transform = 'translateY(' + (20 * (1 - greenP)) + 'px)'; }
      if (black) { black.style.opacity = blackP; black.style.transform = 'translateY(' + (20 * (1 - blackP)) + 'px)'; }
      if (copy) { copy.style.opacity = copyP; copy.style.transform = 'translateY(' + (16 * (1 - copyP)) + 'px)'; }

      // NAYA: fade poora hote hi carousel tak auto smooth-scroll
      if (progress >= 0.98 && progress < 0.995 && !hasSnapped && carousel) {
        hasSnapped = true;
        var targetY = window.scrollY + carousel.getBoundingClientRect().top;
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      }
      // agar user wapas upar scroll kare to dobara trigger ho sake
      if (progress < 0.5 && hasSnapped) {
        hasSnapped = false;
      }
    }
    function requestTick() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick);
    update();
  }
  function init() {
    initBacopaFill();
    initCdriReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  /* ----------------------------------------------------------
     CDRI-55 STICKY CAROUSEL
  ---------------------------------------------------------- */
  (function cdriCarousel() {
    var section = document.querySelector('#mw-cdri-carousel');
    if (!section) return;

    var steps    = section.querySelectorAll('[data-step]');
    var images   = section.querySelectorAll('[data-slide]');
    var texts    = section.querySelectorAll('[data-slide-text]');
    var titles   = section.querySelectorAll('[data-slide-title]');
    var facts    = section.querySelectorAll('[data-fact]');
    var copies = section.querySelectorAll('[data-copy]');
    var icons    = section.querySelectorAll('[data-icon]');
    var counters = section.querySelectorAll('[data-counter-current]');
    var quicks   = section.querySelectorAll('[data-quick]'); // NEW

    function setActiveStep(index) {
      images.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-slide') === String(index));
      });
      texts.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-slide-text') === String(index));
      });
      titles.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-slide-title') === String(index));
      });
      facts.forEach(function (f) {
        f.classList.toggle('is-active', f.getAttribute('data-fact') === String(index));
      });
      copies.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-copy') === String(index));
      });
      icons.forEach(function (ic) {
        ic.classList.toggle('is-active', ic.getAttribute('data-icon') === String(index));
      });
      quicks.forEach(function (q) { // NEW
        q.classList.toggle('is-active', q.getAttribute('data-quick') === String(index));
      });
      counters.forEach(function (c) {
        c.textContent = String(index + 1).padStart(2, '0');
      });
    }

    function updateOnScroll() {
      var viewportMid = window.innerHeight / 2;
      var activeIndex = 0;
      steps.forEach(function (step, i) {
        var rect = step.getBoundingClientRect();
        if (rect.top <= viewportMid && rect.bottom >= viewportMid) {
          activeIndex = i;
        }
      });
      setActiveStep(activeIndex);
    }

    window.addEventListener('scroll', function () {
      requestAnimationFrame(updateOnScroll);
    }, { passive: true });

    window.addEventListener('resize', updateOnScroll);

    function isMobile() {
      return window.innerWidth <= 900;
    }

    function updateMobileTextScroll() {
      if (!isMobile()) return;
      steps.forEach(function (step, i) {
        var rect = step.getBoundingClientRect();
        var stepHeight = rect.height - window.innerHeight;
        if (stepHeight <= 0) return;
        var progress = (0 - rect.top) / stepHeight;
        progress = Math.min(1, Math.max(0, progress));
        var scrollArea = section.querySelectorAll('.mw-cdri-carousel__panel-bottom')[i];
        if (scrollArea) {
          var maxScroll = scrollArea.scrollHeight - scrollArea.clientHeight;
          if (maxScroll > 0) {
            scrollArea.scrollTop = progress * maxScroll;
          }
        }
      });
    }

    window.addEventListener('scroll', function () {
      requestAnimationFrame(function () {
        updateOnScroll();
        updateMobileTextScroll();
      });
    }, { passive: true });

    setActiveStep(0);
    updateOnScroll();
  })();
 /* ----------------------------------------------------------
     KEY BENEFITS — scroll marquee + continuous card parallax
  ---------------------------------------------------------- */
  (function keyBenefits() {
  var track = document.querySelector('.mkb__bg-text-track');
  var ticking = false;

  function updateScrollFx() {
    if (track) {
      var section = document.getElementById('mindwise-key-benefits');
      if (section) {
        var rect = section.getBoundingClientRect();
        var viewH = window.innerHeight;
        var sectionH = section.offsetHeight;

        var scrolled = viewH - rect.top;
        var scrollableDist = sectionH + viewH;
        var scrollProgress = Math.max(0, Math.min(scrolled / scrollableDist, 1));

        var startOffset = window.innerWidth;
        var maxShift = track.scrollWidth * 0.5 + startOffset;
        var shift = scrollProgress * maxShift;
        var finalX = startOffset - shift;
        track.style.transform = 'translateX(' + finalX + 'px)';
      }
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(updateScrollFx); ticking = true; }
  }, { passive: true });
  updateScrollFx();

  // ── Entrance reveal for accordion items ──
  var items = document.querySelectorAll('.mkb__acc-item');
  if (items.length) {
    if ('IntersectionObserver' in window) {
      var revealObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mkb--visible');
            revealObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      items.forEach(function (item) { revealObs.observe(item); });
    } else {
      items.forEach(function (item) { item.classList.add('mkb--visible'); });
    }
  }

  // ── Accordion toggle (single-open) ──
  items.forEach(function (item) {
    var trigger = item.querySelector('.mkb__acc-trigger');
    var panel = item.querySelector('.mkb__acc-panel');

    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('mkb--open');

      items.forEach(function (other) {
        if (other !== item) {
          other.classList.remove('mkb--open');
          other.querySelector('.mkb__acc-trigger').setAttribute('aria-expanded', 'false');
          other.querySelector('.mkb__acc-panel').style.maxHeight = 0;
        }
      });

      if (isOpen) {
        item.classList.remove('mkb--open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.style.maxHeight = 0;
      } else {
        item.classList.add('mkb--open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
})();
/* ----------------------------------------------------------
   SCIENCE BANNER — SCROLL-LINKED BRAIN + STATS + LINES
---------------------------------------------------------- */
(function scienceBannerScroll() {
  var section = document.querySelector('#mw-science-banner');
  if (!section) return;

  var track     = section.querySelector('.mw-science-banner__bg-track');
  var brainWrap = section.querySelector('#mwBrainWrap');
  var group1    = section.querySelectorAll('[data-group="1"]');
  var group2    = section.querySelectorAll('[data-group="2"]');
  var lines1    = section.querySelectorAll('.mw-line[data-group="1"]');
  var lines2    = section.querySelectorAll('.mw-line[data-group="2"]');

  var countedGroups = {};

  function getProgress() {
    var rect = section.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    if (total <= 0) return 0;
    var scrolled = -rect.top;
    return Math.min(1, Math.max(0, scrolled / total));
  }

  function trapezoid(p, start, fadeInEnd, fadeOutStart, end) {
    if (p <= start || p >= end) return 0;
    if (p < fadeInEnd) return (p - start) / (fadeInEnd - start);
    if (p > fadeOutStart) return (end - p) / (end - fadeOutStart);
    return 1;
  }

  function animateCountUp(groupEls) {
    groupEls.forEach(function (el) {
      var raw = el.dataset.stat;
      if (!raw || !/^\d+$/.test(raw)) return;
      var numEl = el.querySelector('.mw-stat-callout__num');
      if (!numEl) return;
      var target = parseInt(raw, 10);
      var duration = 900;
      var startTime = null;

      function step(ts) {
        if (!startTime) startTime = ts;
        var p = Math.min(1, (ts - startTime) / duration);
        numEl.textContent = Math.floor(p * target) + '%';
        if (p < 1) requestAnimationFrame(step);
        else numEl.textContent = target + '%';
      }
      requestAnimationFrame(step);
    });
  }

  function update() {
    var progress = getProgress();

   // background text: starts partially visible near brain area, moves left with scroll
    if (track) {
      var startOffset = window.innerWidth * 0.6;
      var maxShift = track.scrollWidth * 0.5 + startOffset;
      var shift = progress * maxShift;
      var finalX = startOffset - shift;
      track.style.transform = 'translateX(' + finalX + 'px)';
    }

    // brain: left -> center -> right (rotation hata di)
    var brainX;
    if (progress < 0.12) {
      var p1 = progress / 0.12;
      brainX = 34 - p1 * 34;
    } else if (progress > 0.88) {
      var p2 = (progress - 0.88) / 0.12;
      brainX = p2 * 34;
    } else {
      brainX = 0;
    }

    if (brainWrap) {
      brainWrap.style.transform = 'translateX(' + brainX + '%)';
    }

    // stat groups + connector lines
    var g1 = trapezoid(progress, 0.10, 0.24, 0.42, 0.50);
    var g2 = trapezoid(progress, 0.56, 0.68, 0.82, 0.90);
    var overlay = section.querySelector('#mwFadeOverlay');
    var overlayP = Math.max(0, Math.min(1, (progress - 0.93) / 0.07));
    if (overlay) overlay.style.opacity = overlayP;
    group1.forEach(function (el) { el.classList.toggle('is-active', g1 > 0.05); });
    group2.forEach(function (el) { el.classList.toggle('is-active', g2 > 0.05); });
    lines1.forEach(function (l) { l.classList.toggle('is-active', g1 > 0.05); });
    lines2.forEach(function (l) { l.classList.toggle('is-active', g2 > 0.05); });

    if (g1 > 0.5 && !countedGroups.g1) {
      countedGroups.g1 = true;
      animateCountUp(group1);
    }
    if (g2 > 0.5 && !countedGroups.g2) {
      countedGroups.g2 = true;
      animateCountUp(group2);
    }
  }

  window.addEventListener('scroll', function () {
    requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('resize', update);

  update();
})();
  
(function ratingPopover() {
  document.querySelectorAll('[data-rating-trigger]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.stopPropagation();
      el.classList.toggle('is-open');
    });
  });

  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-rating-trigger].is-open').forEach(function (el) {
      if (!el.contains(e.target)) el.classList.remove('is-open');
    });
  });
})();
/* ----------------------------------------------------------
   ADVANTAGE HERO + TABLE — SCROLL-LINKED REVEAL
---------------------------------------------------------- */

/* ----------------------------------------------------------
     4. STUDIES CAROUSEL — accurate movement + snap + polish
  ---------------------------------------------------------- */
  (function studiesCarousel() {

    var section   = document.querySelector('#mw-studies');
    var track     = document.querySelector('[data-studies-track]');
    var trackWrap = document.querySelector('.mw-studies__track-wrap');
    if (!section || !track || !trackWrap) {
      console.warn('[studiesCarousel] required elements missing, aborting');
      return;
    }

    var cards    = track.querySelectorAll('.mw-studies__card');
    var dotsWrap = document.querySelector('[data-studies-dots]');
    var dots     = dotsWrap ? dotsWrap.querySelectorAll('[data-dot]') : [];
    var prevBtn  = dotsWrap ? dotsWrap.querySelector('[data-dot-prev]') : null;
    var nextBtn  = dotsWrap ? dotsWrap.querySelector('[data-dot-next]') : null;

    var maxTranslate = 0;
    var currentX = 0;
    var targetX = 0;

    function computeMax() {
      maxTranslate = Math.max(0, track.scrollWidth - trackWrap.clientWidth);

      if (maxTranslate < 10) {
        console.warn('[studiesCarousel] maxTranslate is ~0 — cards are not overflowing. Check that .mw-studies__track has flex-wrap:nowrap and cards have a fixed width.');
      }

      // section's own scroll height = exact horizontal distance + 1 viewport
      section.style.height = (maxTranslate + window.innerHeight) + 'px';
    }

    function getSectionProgress() {
      var rect = section.getBoundingClientRect();
      var total = section.offsetHeight - window.innerHeight;
      if (total <= 0) return 0;
      var scrolled = -rect.top;
      return Math.min(1, Math.max(0, scrolled / total));
    }

    function getActiveIndex(translateX) {
      var center = translateX + trackWrap.clientWidth / 2;
      var closestIndex = 0, closestDist = Infinity;
      cards.forEach(function (card, i) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var dist = Math.abs(cardCenter - center);
        if (dist < closestDist) { closestDist = dist; closestIndex = i; }
      });
      return closestIndex;
    }

    function updateTarget() {
      targetX = getSectionProgress() * maxTranslate;
    }

    function animate() {
      currentX += (targetX - currentX) * 0.15; // thoda tighter follow — zyada "accurate" feel
      if (Math.abs(targetX - currentX) < 0.05) currentX = targetX;

      track.style.transform = 'translate3d(-' + currentX.toFixed(2) + 'px,0,0)';

      var idx = getActiveIndex(currentX);
      cards.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });

      requestAnimationFrame(animate);
    }

    function progressForCardIndex(index) {
      var card = cards[index];
      if (!card || maxTranslate <= 0) return 0;
      var desired = (card.offsetLeft + card.offsetWidth / 2) - trackWrap.clientWidth / 2;
      desired = Math.min(maxTranslate, Math.max(0, desired));
      return desired / maxTranslate;
    }

    function scrollToCardIndex(index) {
      var rect = section.getBoundingClientRect();
      var sectionTop = rect.top + window.scrollY;
      var total = section.offsetHeight - window.innerHeight;
      var target = sectionTop + progressForCardIndex(index) * total;
      window.scrollTo({ top: target, behavior: 'smooth' });
    }

    function currentActiveIndex() {
      var active = 0;
      cards.forEach(function (c, i) { if (c.classList.contains('is-active')) active = i; });
      return active;
    }

    // ---------- SNAP TO NEAREST CARD WHEN SCROLL STOPS ----------
    var scrollEndTimer = null;
    var isSnapping = false;

    function scheduleSnap() {
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(snapToNearestCard, 140);
    }

    function snapToNearestCard() {
      if (isSnapping) return;
      var rect = section.getBoundingClientRect();
      var isPinned = rect.top <= 0 && rect.bottom >= window.innerHeight;
      if (!isPinned) return;

      var idx = getActiveIndex(targetX);
      isSnapping = true;
      scrollToCardIndex(idx);
      setTimeout(function () { isSnapping = false; }, 500);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { scrollToCardIndex(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () {
      scrollToCardIndex(Math.max(0, currentActiveIndex() - 1));
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      scrollToCardIndex(Math.min(cards.length - 1, currentActiveIndex() + 1));
    });

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        if (currentActiveIndex() !== i) scrollToCardIndex(i);
      });
    });

    window.addEventListener('scroll', function () {
      updateTarget();
      scheduleSnap();
    }, { passive: true });

    window.addEventListener('resize', function () { computeMax(); updateTarget(); });
    window.addEventListener('load', function () { computeMax(); updateTarget(); });

    computeMax();
    updateTarget();
    animate();
    setTimeout(function () { computeMax(); updateTarget(); }, 400);
  })();




/* Advantage Table

(function advHeroScroll() {
  var section = document.querySelector('#mw-adv-hero');
  if (!section) return;

  var heading = section.querySelector('#mwAdvHeading');
  var arrow   = section.querySelector('#mwAdvArrow');
  var product = section.querySelector('#mwAdvProduct');
  var table   = section.querySelector('#mwAdvTable');
  var glow    = section.querySelector('#mwAdvGlow');
  var fadeOverlay = section.querySelector('#mwAdvFadeOverlay');
  var fadeOverlayTop = section.querySelector('#mwAdvFadeOverlayTop');
var fadeOverlayBottom = section.querySelector('#mwAdvFadeOverlayBottom');

  if (!heading || !product || !table || !glow) return;

  function clamp(v) { return Math.min(1, Math.max(0, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }

  function getProgress() {
    var rect = section.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    if (total <= 0) return 0;
    return clamp(-rect.top / total);
  }

  function update() {
    var p = getProgress();
    var isMobile = window.innerWidth <= 768;

    // TOP overlay (existing)
var topFade = clamp(p / 0.01);
if (fadeOverlayTop) {
  fadeOverlayTop.style.opacity = 1 - topFade;
}

// BOTTOM overlay (reverse)
var bottomFade = clamp((1 - p) / 0.01);
if (fadeOverlayBottom) {
  fadeOverlayBottom.style.opacity = 1 - bottomFade;
}

var fadeMask = clamp((p - 0.985) / 0.003);
section.style.setProperty("--fade", (fadeMask * 100) + "%");


    
    // Heading fade + shrink
    var headingScale = lerp(1, 0.82, clamp(p / 0.6));
    var headingY = lerp(0, -40, clamp(p / 0.6));
    var headingOpacity = lerp(1, 0.35, clamp(p / 0.5));
    heading.style.opacity = headingOpacity;
    heading.style.transform = 'translateY(' + headingY + 'px) scale(' + headingScale + ')';

    if (arrow) {
      arrow.style.opacity = clamp(1 - p / 0.22);
    }

    // PHASE 1: product fade-in at center (0.25 -> 0.5)
    var productFadeT = clamp((p - 0.25) / 0.25);

    // PHASE 2: product shifts center -> left (0.5 -> 0.7), table still hidden
    var productShiftT = clamp((p - 0.5) / 0.2);

    // PHASE 3: table fades in (0.7 -> 0.95), product already static at left
    var tableT = clamp((p - 0.7) / 0.25);

    var productShiftX = isMobile ? 0 : lerp(22, -6, productShiftT);
    var productOpacity = productFadeT;
    var productY = lerp(60, 0, productFadeT);
    var productScale = lerp(0.85, 1, productFadeT) + (tableT * 0.05);

    product.style.opacity = productOpacity;
    product.style.transform =
      'translate(' + productShiftX + 'vw, ' + productY + 'px) scale(' + productScale + ')';

    table.style.opacity = tableT;
    table.style.transform = 'translateY(' + lerp(40, 0, tableT) + 'px)';

    var glowOpacity = lerp(0.5, 1, clamp(p / 0.6)) - (clamp((p - 0.85) / 0.15) * 0.3);
    glow.style.opacity = glowOpacity;
    var glowX = lerp(25, 50, clamp(p / 0.7));
    glow.style.background =
      'radial-gradient(circle at ' + glowX + '% 70%, rgba(139, 201, 38, 0.45) 0%, transparent 55%)';
  }

  window.addEventListener('scroll', function () {
    requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('resize', update);

  update();
})();*/

  
  /* ----------------------------------------------------------
     5. FAQ ACCORDION
  ---------------------------------------------------------- */
  (function faqAccordion() {
    var items = document.querySelectorAll('[data-faq]');
    if (!items.length) return;

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-faq-toggle]');
      var answer = item.querySelector('.mw-faq__answer');
      if (!toggle || !answer) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (other) {
          other.classList.remove('is-open');
          var a = other.querySelector('.mw-faq__answer');
          if (a) a.style.maxHeight = null;
        });

        if (!isOpen) {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  })();


/* ----------------------------------------------------------
   TESTIMONIALS
---------------------------------------------------------- */
(function testimonialsInit() {

  const section = document.getElementById("mw-testimonials");
  if (!section) return;

  /* ==========================
      MARQUEE + PARALLAX
  ========================== */

  const track = section.querySelector("[data-testimonials-track]");
  const cards = section.querySelectorAll(".mw-testimonials__photo-card");

  let trackWidth = 0;
  let currentX = 0;
  let targetX = 0;

  // active card (-1 means none)
  let activeCard = -1;

  function getTrackWidth() {
    if (!track) return;
    trackWidth = track.scrollWidth / 2;
  }

  function animate() {

    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight;

    if (rect.bottom > 0 && rect.top < vh) {

      let progress = (vh - rect.top) / (vh + rect.height);
      progress = Math.max(0, Math.min(1, progress));

      /* ==========================
         Background Text
      ========================== */

      targetX = -(trackWidth * 0.75 * progress);
      currentX += (targetX - currentX) * 0.08;

      track.style.transform =
        `translate3d(${currentX}px,0,0)`;

      /* ==========================
         Cards Animation
      ========================== */

      cards.forEach((card, index) => {

        // Animation tabhi start hogi jab section ka 30% viewport me aa jaye
let start = 0.30;
let end = 1;

let cardProgress = (progress - start) / (end - start);
cardProgress = Math.max(0, Math.min(1, cardProgress));

let scrollMove = cardProgress * 220;

        // When a quote is open,
        // move every card further upward
        let activeLift = activeCard !== -1 ? 60 : 0;

        let translate = scrollMove + activeLift;

        let rotate = 0;

        if (index === activeCard) {

          if (index === 0) rotate = -5;
          if (index === 1) rotate = -5;
          if (index === 2) rotate = 5;

        }

        card.style.transform =
          `translate3d(0,-${translate}px,0) rotate(${rotate}deg)`;

      });

    }

    requestAnimationFrame(animate);

  }

  getTrackWidth();
  animate();

  window.addEventListener("resize", getTrackWidth);



  /* ==========================
        QUOTE OVERLAY
  ========================== */

  const dots = section.querySelectorAll("[data-tdot]");
  const showBtns = section.querySelectorAll("[data-show-quote]");

  function overlays() {
    return section.querySelectorAll("[data-quote-overlay]");
  }

  function hideAll() {
    overlays().forEach(o => {
      o.classList.remove("is-visible");
    });
  }

  function setDot(index) {
    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === index);
    });
  }

  function showQuote(index) {

    activeCard = index;

    hideAll();

    const overlay = section.querySelector(
      `[data-quote-overlay="${index}"]`
    );

    if (overlay) {
      overlay.classList.add("is-visible");
    }

    setDot(index);

  }

  function resetCards() {

    activeCard = -1;

    hideAll();

    dots.forEach(dot => {
      dot.classList.remove("active");
    });

  }

  /* Image / Card Click */

  const photoCards = section.querySelectorAll(".mw-testimonials__photo-card");

  photoCards.forEach(card => {

    const wrap = card.querySelector(".mw-testimonials__photo-wrap");

    if (wrap) {
      wrap.style.cursor = "pointer";

      wrap.addEventListener("click", function () {
        showQuote(
          Number(card.dataset.tcard)
        );
      });
    }

  });
  /* Arrow Click */

  showBtns.forEach(btn => {

    btn.addEventListener("click", function(e){

      e.stopPropagation();

      showQuote(
        Number(btn.dataset.showQuote)
      );

    });

  });

  /* Close Button */

  section.addEventListener("click", function(e){

    const close = e.target.closest("[data-quote-close]");

    if(!close) return;

    const overlay = section.querySelector(
      `[data-quote-overlay="${close.dataset.quoteClose}"]`
    );

    if(overlay){
      overlay.classList.remove("is-visible");
    }

    resetCards();

  });

  /* Dots */

  dots.forEach((dot,index)=>{

    dot.addEventListener("click",()=>{

      showQuote(index);

    });

  });

})();
  
/* ----------------------------------------------------------
     6. STORY — pinned scroll sequence (heading → quote → clippings → CTA)
  ---------------------------------------------------------- */
(function storyInit() {
    var section = document.getElementById('mw-story');
    if (!section) return;

    var intro   = section.querySelector('[data-story-intro]');
    var content = section.querySelector('[data-story-content]');
    var clips   = section.querySelectorAll('[data-story-clip]');
    var dot     = section.querySelector('[data-story-dot]');
    var fadeOverlay = section.querySelector('[data-story-fade]');
    var cta     = section.querySelector('[data-story-cta]');

    var clipCount = clips.length;
    var rotations = [-6, 4, -2, 5, -4];

    function clamp01(v) { return Math.max(0, Math.min(1, v)); }
    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

    function getProgress() {
      var rect = section.getBoundingClientRect();
      var scrollable = rect.height - window.innerHeight;
      if (scrollable <= 0) return 0;
      return clamp01(-rect.top / scrollable);
    }

    var INTRO_HOLD_END = 0.20;  // yaha tak text fully visible rahega
var INTRO_END      = 0.32;  // is point tak fade-out complete hoga
var CONTENT_START  = 0.32;
var CONTENT_END    = 0.42;
var CLIPS_START    = 0.42;
var CLIPS_END      = 0.92;
var CTA_START      = 0.85;

    function update() {
      var p = getProgress();

      // white overlay fade-out shuru me hi
      var overlayP = clamp01(p / 0.08);
      if (fadeOverlay) fadeOverlay.style.opacity = String(1 - overlayP);

      var introP;
if (p <= INTRO_HOLD_END) {
  introP = 0; // fully visible, no fade yet
} else {
  introP = clamp01((p - INTRO_HOLD_END) / (INTRO_END - INTRO_HOLD_END));
}
intro.style.opacity = String(1 - introP);
intro.style.transform = 'translateY(' + (-introP * 40) + 'px)';
intro.style.pointerEvents = introP >= 1 ? 'none' : 'auto';

      var contentP = clamp01((p - CONTENT_START) / (CONTENT_END - CONTENT_START));
      content.style.opacity = String(contentP);
       // NEW: image aane ke saath text upar shift
      var clipsRaw = clamp01((p - CLIPS_START) / (CLIPS_END - CLIPS_START));
      content.style.transform = 'translateY(' + (-clipsRaw * 80) + 'px)';

      // har clip apni turn se: chhota-neeche -> bada-center (button) -> chhota-upar (fade)
      var clipSpan = (CLIPS_END - CLIPS_START) / clipCount;
      // Sabhi clips ek saath row mein aate hain, halka stagger ke saath
      var STAGGER = 0.06; // har clip thoda late shuru hota hai (cascade feel)
      var ENTRANCE_DUR = 0.5; // is window mein entrance complete

      clips.forEach(function (clip, i) {
        var localStart = i * STAGGER;
        var raw = clamp01((p - CLIPS_START) / (CLIPS_END - CLIPS_START));
        var local = clamp01((raw - localStart) / ENTRANCE_DUR);

        var rot = rotations[i % rotations.length] * 0.5; // halka tilt, row mein zyada clean rahe

        var t = easeOutCubic(local);
        var y = 60 * (1 - t);
        var scale = 0.75 + 0.25 * t;
        var opacity = t;
        var rotation = rot * (1 - t);

        clip.style.transform = 'translateY(' + y + 'vh) scale(' + scale + ') rotate(' + rotation + 'deg)';
        clip.style.opacity = String(opacity);
        clip.style.zIndex = String(i + 1);
      });

      var ctaVisible = p >= CTA_START;
      if (cta) cta.classList.toggle('is-visible', ctaVisible);
      if (dot) dot.classList.toggle('is-visible', ctaVisible);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();
  /* ----------------------------------------------------------
   STICKY ADD TO CART — visibility + live price/image sync + qty
---------------------------------------------------------- */
(function stickyAddToCart() {
  var stickyBar    = document.querySelector('#mwStickyAtc');
  var stickyBtn    = document.querySelector('#mwStickyAtcBtn');
  var stickyPrice  = document.querySelector('#mwStickyAtcPrice');
  var stickyImg    = document.querySelector('#mwStickyAtcImg');
  var stickyMinus  = document.querySelector('#mwStickyMinus');
  var stickyPlus   = document.querySelector('#mwStickyPlus');
  var stickyQtyVal = document.querySelector('#mwStickyQtyVal');

  if (!stickyBar) return;

  /* --- 1. Visibility: show sticky bar when the real Add to Cart button
     scrolls out of view --- */
  var originalBtn = document.querySelector(
    '.product-form__submit, [name="add"], .product-form__cart-submit, button[type="submit"][name="add"]'
  );

  var isBarVisible = false;

  function applyBarSpacing() {
    if (!isBarVisible) return;
    var barHeight = stickyBar.offsetHeight;
    document.body.style.paddingBottom = barHeight + 'px';
    document.documentElement.style.setProperty('--mw-atc-h', barHeight + 'px');
  }

  if (originalBtn) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        isBarVisible = !entry.isIntersecting;
        stickyBar.classList.toggle('is-visible', isBarVisible);
        if (isBarVisible) {
          applyBarSpacing();
        } else {
          document.body.style.paddingBottom = '';
          document.documentElement.style.setProperty('--mw-atc-h', '0px');
        }
      });
    }, { threshold: 0 });
    observer.observe(originalBtn);
  }

  /* Bar ki height agar resize (mobile rotate, window resize) se change ho,
     to padding bhi turant sync rahe — koi extra/kam gap na aaye */
  var resizeObserver = new ResizeObserver(applyBarSpacing);
  resizeObserver.observe(stickyBar);
  window.addEventListener('resize', applyBarSpacing);

  /* --- 2. Live price sync: watch the main product price element for any
     text change (variant switch, quantity break pricing, etc.) and mirror it --- */
  var mainPriceEl = document.querySelector(
    '.price__regular .price-item--regular, .product__price, .price-item, [data-product-price]'
  );

  if (mainPriceEl && stickyPrice) {
    var priceObserver = new MutationObserver(function () {
      var text = mainPriceEl.textContent.trim();
      if (text) stickyPrice.textContent = text;
    });
    priceObserver.observe(mainPriceEl, { childList: true, characterData: true, subtree: true });
    // set initial value in case format differs from Liquid default
    if (mainPriceEl.textContent.trim()) {
      stickyPrice.textContent = mainPriceEl.textContent.trim();
    }
  }

  /* --- 3. Live image sync: watch main product featured image for src changes --- */
  var mainImgEl = document.querySelector(
    '.product__media img, .product-single__photo img, [data-product-featured-image]'
  );

  if (mainImgEl && stickyImg) {
    var imgObserver = new MutationObserver(function () {
      if (mainImgEl.src) stickyImg.src = mainImgEl.src;
    });
    imgObserver.observe(mainImgEl, { attributes: true, attributeFilter: ['src'] });
  }

  /* --- 4. Quantity stepper: sync with main quantity input if it exists --- */
  var mainQtyInput = document.querySelector('input[name="quantity"]');
  var qty = 1;

  function updateQtyDisplay() {
    stickyQtyVal.textContent = qty;
    if (mainQtyInput) {
      mainQtyInput.value = qty;
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (stickyMinus && stickyPlus && stickyQtyVal) {
    stickyMinus.addEventListener('click', function () {
      qty = Math.max(1, qty - 1);
      updateQtyDisplay();
    });
    stickyPlus.addEventListener('click', function () {
      qty = qty + 1;
      updateQtyDisplay();
    });
  }

  /* --- 5. Click sticky button => trigger the real Add to Cart button --- */
  if (stickyBtn && originalBtn) {
    stickyBtn.addEventListener('click', function () {
      originalBtn.click();
    });
  }
})();


/* ----------------------------------------------------------
   FAQ HEADING — subtle scroll-linked parallax movement
---------------------------------------------------------- */
/* ----------------------------------------------------------
   FAQ HEADING — center start (CSS flex handles centering), 
   right-to-left drift on scroll
---------------------------------------------------------- */
(function faqHeadingParallax() {
  var section = document.querySelector('#mw-faq');
  var heading = document.querySelector('.mw-faq__heading');
  if (!section || !heading) return;

  var ticking = false;
  var BASE_Y = -20;     // CSS ka static translateY(-20px) preserve karo
  var MAX_SHIFT = 400;  // px — total right-to-left drift, tune karo

  function update() {
    ticking = false;
    var rect = section.getBoundingClientRect();
    var viewportH = window.innerHeight;

    var total = rect.height + viewportH;
    if (total <= 0) return;

    var scrolled = viewportH - rect.top;
    var progress = Math.min(1, Math.max(0, scrolled / total));

    // progress = 0 -> translateX = 0 (CSS ki justify-content:center
    // yahan pehle se center kar chuki hai, JS dobara offset nahi jodega)
   const START_OFFSET = 550;
const MAX_SHIFT = 2000;

var translateX = START_OFFSET - (progress * MAX_SHIFT);

heading.style.transform =
  `translate3d(${translateX}px, ${BASE_Y}px, 0)`;
  }

  function requestTick() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  update();
})();

(function testiEntryFade() {
  var section = document.querySelector('#mw-testimonials');
  var overlay = document.querySelector('#mwTestiOverlay');
  if (!section || !overlay) return;

  function clamp(v) { return Math.min(1, Math.max(0, v)); }

  var MAX_HEIGHT = 1250; // overlay ki shuruaati height, adjust kar sakte ho

  function update() {
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight;

    var fadeDistance = vh * 0.5;
    var progress = clamp((vh - rect.top) / fadeDistance);

    // Opacity ki jagah HEIGHT animate karo — parda upar simat jayega
    var currentHeight = MAX_HEIGHT * (1 - progress);
    overlay.style.height = currentHeight + 'px';
  }

  window.addEventListener('scroll', function () {
    requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('resize', update);

  update();
})();


(function(){
  var section = document.querySelector('.mw-testimonials');
  var row = document.querySelector('[data-trow]');
  if(!section || !row) return;

  var isMobile = window.matchMedia('(max-width:768px)');

  var targetX, currentX, ease = 0.08;

 function ranges(){
  return isMobile.matches
    ? { start: 320, end: -380 }
    : { start: 420, end: -420 };
}

ease = isMobile.matches ? 0.18 : 0.08;
  var r = ranges();
  targetX = currentX = r.start;

  function computeTarget(){
    r = ranges();
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight;
    var raw = (vh - rect.top) / (vh + rect.height);
    var progress = Math.max(0, Math.min(1, raw));
    return r.start + (r.end - r.start) * progress;
  }

  function onScroll(){ targetX = computeTarget(); }

  function tick(){
    currentX += (targetX - currentX) * ease;
    row.style.transform = 'translate3d(' + currentX.toFixed(2) + 'px,0,0)';
    requestAnimationFrame(tick);
  }

  window.addEventListener('scroll', onScroll, { passive:true });
  window.addEventListener('resize', onScroll);
  onScroll();
  requestAnimationFrame(tick);
})();


(function(){
const DATA=[{"n":"Trial 1","t":"Faster thinking, calmer mind","cite":"Stough et al., 2001","cred":"46 adults · 12 weeks · 300 mg/day","sold":"KeenMind","status":"primary","src":"Chronic effects of Bacopa monnieri on cognition in healthy adults · Psychopharmacology 2001;156(4):481–484","design":["Randomised","Double-blind","Placebo-controlled (parallel)","12 weeks","300 mg/day (2×150 mg)"],"meas":["Visual processing speed (Inspection Time)","Verbal learning & memory (AVLT)","State anxiety (STAI)"],"find":"Faster visual processing (P=0.018), better learning and memory consolidation (forgetting P=0.03), and lower anxiety (P=0.001). Maximal at 12 weeks.","note":"","pub":"https://pubmed.ncbi.nlm.nih.gov/11498727/","drive":"Australian clinical trial 1.pdf (primary held)","dia":"\u003csvg viewBox=\"0 0 300 344\" width=\"100%\" role=\"img\" aria-label=\"Study design flow\">\u003cdefs>\u003cmarker id=\"ah\" markerWidth=\"8\" markerHeight=\"8\" refX=\"6\" refY=\"3\" orient=\"auto\">\u003cpath d=\"M0,0 L6,3 L0,6 Z\" fill=\"#c8f24e\"/>\u003c/marker>\u003c/defs>\u003crect x=\"85\" y=\"14\" width=\"130\" height=\"28\" rx=\"9\" fill=\"#e9ebe6\"/>\u003ctext x=\"150\" y=\"33.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Screening (Day 1)\u003c/text>\u003cline x1=\"150\" y1=\"42\" x2=\"150\" y2=\"64\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"40\" y=\"66\" width=\"220\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"87.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#14161a\">46 participants\u003c/text>\u003ctext x=\"150\" y=\"101.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"500\" letter-spacing=\"0\" fill=\"#4a4f55\">healthy adults · 18–60\u003c/text>\u003cline x1=\"150\" y1=\"110\" x2=\"150\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"220\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"80\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003cline x1=\"220\" y1=\"132\" x2=\"220\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"20\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"80\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Placebo (n=23)\u003c/text>\u003crect x=\"160\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"220\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">CDRI-55 (n=23)\u003c/text>\u003cline x1=\"80\" y1=\"186\" x2=\"80\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"220\" y1=\"186\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"208\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"150\" y1=\"208\" x2=\"150\" y2=\"224\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"30\" y=\"226\" width=\"240\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"245.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"9.5\" font-weight=\"700\" letter-spacing=\"0.5\" fill=\"#3a5a00\">ASSESSED AT\u003c/text>\u003ctext x=\"150\" y=\"260\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Baseline  ·  Week 5  ·  Week 12\u003c/text>\u003cline x1=\"150\" y1=\"270\" x2=\"150\" y2=\"290\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"62\" y=\"292\" width=\"176\" height=\"38\" rx=\"9\" fill=\"#c8f24e\"/>\u003ctext x=\"150\" y=\"317.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#0e0f13\">300 mg/day\u003c/text>\u003c/svg>","type":"trial"},{"n":"Trial 2","t":"Holds on to what it learns","cite":"Roodenrys et al., 2002","cred":"76 adults · 3 months · 300 mg/day","sold":"KeenMind","status":"primary","src":"Chronic effects of Brahmi (Bacopa monnieri) on human memory · Neuropsychopharmacology 2002;27(2):279–281","design":["Randomised","Double-blind","Placebo-controlled (parallel)","3 months","300 mg/day (450 mg if >90 kg)"],"meas":["Delayed recall of newly-learned word pairs","(also tested: working memory, attention, mood)"],"find":"Reduced the rate of forgetting newly-learned information (delayed word-pair recall, p\u003c.05). Authors note this single result may reflect a Type I error, so scope to word-pair retention.","note":"","pub":"https://pubmed.ncbi.nlm.nih.gov/12093601/","drive":"Australian clinical trial 2.pdf (primary held)","dia":"\u003csvg viewBox=\"0 0 300 344\" width=\"100%\" role=\"img\" aria-label=\"Study design flow\">\u003cdefs>\u003cmarker id=\"ah\" markerWidth=\"8\" markerHeight=\"8\" refX=\"6\" refY=\"3\" orient=\"auto\">\u003cpath d=\"M0,0 L6,3 L0,6 Z\" fill=\"#c8f24e\"/>\u003c/marker>\u003c/defs>\u003crect x=\"85\" y=\"14\" width=\"130\" height=\"28\" rx=\"9\" fill=\"#e9ebe6\"/>\u003ctext x=\"150\" y=\"33.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Screening (Day 1)\u003c/text>\u003cline x1=\"150\" y1=\"42\" x2=\"150\" y2=\"64\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"40\" y=\"66\" width=\"220\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"87.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#14161a\">76 participants\u003c/text>\u003ctext x=\"150\" y=\"101.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"500\" letter-spacing=\"0\" fill=\"#4a4f55\">adults · 40–65\u003c/text>\u003cline x1=\"150\" y1=\"110\" x2=\"150\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"220\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"80\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003cline x1=\"220\" y1=\"132\" x2=\"220\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"20\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"80\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Placebo (n=39)\u003c/text>\u003crect x=\"160\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"220\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">CDRI-55 (n=37)\u003c/text>\u003cline x1=\"80\" y1=\"186\" x2=\"80\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"220\" y1=\"186\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"208\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"150\" y1=\"208\" x2=\"150\" y2=\"224\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"30\" y=\"226\" width=\"240\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"245.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"9.5\" font-weight=\"700\" letter-spacing=\"0.5\" fill=\"#3a5a00\">ASSESSED AT\u003c/text>\u003ctext x=\"150\" y=\"260\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Baseline  ·  3 months  ·  +6-wk f/up\u003c/text>\u003cline x1=\"150\" y1=\"270\" x2=\"150\" y2=\"290\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"62\" y=\"292\" width=\"176\" height=\"38\" rx=\"9\" fill=\"#c8f24e\"/>\u003ctext x=\"150\" y=\"317.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#0e0f13\">300 mg/day\u003c/text>\u003c/svg>","type":"trial"},{"n":"Trial 3","t":"Sharper working memory","cite":"Stough et al., 2008","cred":"62 adults · 90 days · 300 mg/day","sold":"KeenMind","status":"summary","src":"Nootropic effects of Bacopa monnieri, a 90-day trial · Phytotherapy Research 2008;22(12):1629–1634","design":["Randomised","Double-blind","Placebo-controlled","90 days","300 mg/day"],"meas":["Working memory","Visual information processing"],"find":"Improved working-memory accuracy (p\u003c0.035) and reduced errors in rapid visual information processing.","note":"","pub":"https://pubmed.ncbi.nlm.nih.gov/18683852/","drive":"Summary via KeenMind clinical review — obtain the primary","dia":"\u003csvg viewBox=\"0 0 300 344\" width=\"100%\" role=\"img\" aria-label=\"Study design flow\">\u003cdefs>\u003cmarker id=\"ah\" markerWidth=\"8\" markerHeight=\"8\" refX=\"6\" refY=\"3\" orient=\"auto\">\u003cpath d=\"M0,0 L6,3 L0,6 Z\" fill=\"#c8f24e\"/>\u003c/marker>\u003c/defs>\u003crect x=\"85\" y=\"14\" width=\"130\" height=\"28\" rx=\"9\" fill=\"#e9ebe6\"/>\u003ctext x=\"150\" y=\"33.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Screening (Day 1)\u003c/text>\u003cline x1=\"150\" y1=\"42\" x2=\"150\" y2=\"64\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"40\" y=\"66\" width=\"220\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"87.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#14161a\">62 participants\u003c/text>\u003ctext x=\"150\" y=\"101.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"500\" letter-spacing=\"0\" fill=\"#4a4f55\">healthy adults\u003c/text>\u003cline x1=\"150\" y1=\"110\" x2=\"150\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"220\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"80\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003cline x1=\"220\" y1=\"132\" x2=\"220\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"20\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"80\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Placebo\u003c/text>\u003crect x=\"160\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"220\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">CDRI-55\u003c/text>\u003cline x1=\"80\" y1=\"186\" x2=\"80\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"220\" y1=\"186\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"208\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"150\" y1=\"208\" x2=\"150\" y2=\"224\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"30\" y=\"226\" width=\"240\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"245.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"9.5\" font-weight=\"700\" letter-spacing=\"0.5\" fill=\"#3a5a00\">ASSESSED AT\u003c/text>\u003ctext x=\"150\" y=\"260\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Baseline  ·  Day 90\u003c/text>\u003cline x1=\"150\" y1=\"270\" x2=\"150\" y2=\"290\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"62\" y=\"292\" width=\"176\" height=\"38\" rx=\"9\" fill=\"#c8f24e\"/>\u003ctext x=\"150\" y=\"317.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#0e0f13\">300 mg/day\u003c/text>\u003c/svg>","type":"trial"},{"n":"Trial 4","t":"Support for ageing memory","cite":"Raghav et al., 2006","cred":"55+ · AAMI · 250 mg/day","sold":"CDRI extract","status":"summary","src":"Standardised Bacopa monnieri in age-associated memory impairment · Indian J. Psychiatry 2006;48(4):238–242","design":["Randomised","Double-blind","Placebo-controlled","12 weeks","250 mg/day (125 mg 2×)"],"meas":["Mental control","Logical memory","Paired-associate learning"],"find":"Significant improvement across Wechsler Memory Scale subtests from week 4, greatest on mental control, logical memory and paired-associate learning. Our source calls the data preliminary.","note":"","pub":"https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2915594/","drive":"Summary via Advances chapter 12 — obtain the primary","dia":"\u003csvg viewBox=\"0 0 300 344\" width=\"100%\" role=\"img\" aria-label=\"Study design flow\">\u003cdefs>\u003cmarker id=\"ah\" markerWidth=\"8\" markerHeight=\"8\" refX=\"6\" refY=\"3\" orient=\"auto\">\u003cpath d=\"M0,0 L6,3 L0,6 Z\" fill=\"#c8f24e\"/>\u003c/marker>\u003c/defs>\u003crect x=\"85\" y=\"14\" width=\"130\" height=\"28\" rx=\"9\" fill=\"#e9ebe6\"/>\u003ctext x=\"150\" y=\"33.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Screening (Day 1)\u003c/text>\u003cline x1=\"150\" y1=\"42\" x2=\"150\" y2=\"64\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"40\" y=\"66\" width=\"220\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"87.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#14161a\">Adults with AAMI\u003c/text>\u003ctext x=\"150\" y=\"101.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"500\" letter-spacing=\"0\" fill=\"#4a4f55\">55+ · age-related decline\u003c/text>\u003cline x1=\"150\" y1=\"110\" x2=\"150\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"220\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"80\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003cline x1=\"220\" y1=\"132\" x2=\"220\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"20\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"80\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Placebo\u003c/text>\u003crect x=\"160\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"220\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">CDRI-55\u003c/text>\u003cline x1=\"80\" y1=\"186\" x2=\"80\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"220\" y1=\"186\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"208\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"150\" y1=\"208\" x2=\"150\" y2=\"224\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"30\" y=\"226\" width=\"240\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"245.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"9.5\" font-weight=\"700\" letter-spacing=\"0.5\" fill=\"#3a5a00\">ASSESSED AT\u003c/text>\u003ctext x=\"150\" y=\"260\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Baseline  ·  Wk 4  ·  Wk 8  ·  Wk 12\u003c/text>\u003cline x1=\"150\" y1=\"270\" x2=\"150\" y2=\"290\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"62\" y=\"292\" width=\"176\" height=\"38\" rx=\"9\" fill=\"#c8f24e\"/>\u003ctext x=\"150\" y=\"317.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#0e0f13\">250 mg/day\u003c/text>\u003c/svg>","type":"trial"},{"n":"Trial 5","t":"Works from the first dose","cite":"Downey et al., 2013","cred":"24 adults · single dose · 320/640 mg","sold":"KeenMind","status":"obtain","src":"Acute effects of Bacopa monnieri (CDRI-08) on sustained cognitive performance · Phytotherapy Research 2013;27(9):1407–1413","design":["Randomised","Double-blind","Crossover","Single dose","320 / 640 mg"],"meas":["Sustained attention & accuracy (Cognitive Demand Battery)"],"find":"Improved accuracy on cognitively demanding tasks within about 2 hours of a single dose.","note":"","pub":"https://pubmed.ncbi.nlm.nih.gov/23281132/","drive":"Not in Drive — design from the published record; obtain the paper","dia":"\u003csvg viewBox=\"0 0 300 344\" width=\"100%\" role=\"img\" aria-label=\"Study design flow\">\u003cdefs>\u003cmarker id=\"ah\" markerWidth=\"8\" markerHeight=\"8\" refX=\"6\" refY=\"3\" orient=\"auto\">\u003cpath d=\"M0,0 L6,3 L0,6 Z\" fill=\"#c8f24e\"/>\u003c/marker>\u003c/defs>\u003crect x=\"85\" y=\"14\" width=\"130\" height=\"28\" rx=\"9\" fill=\"#e9ebe6\"/>\u003ctext x=\"150\" y=\"33.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Screening (Day 1)\u003c/text>\u003cline x1=\"150\" y1=\"42\" x2=\"150\" y2=\"64\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"40\" y=\"66\" width=\"220\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"87.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#14161a\">24 participants\u003c/text>\u003ctext x=\"150\" y=\"101.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"500\" letter-spacing=\"0\" fill=\"#4a4f55\">healthy adults\u003c/text>\u003cline x1=\"150\" y1=\"110\" x2=\"150\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"54\" y1=\"132\" x2=\"246\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"54\" y1=\"132\" x2=\"54\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003cline x1=\"150\" y1=\"132\" x2=\"150\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003cline x1=\"246\" y1=\"132\" x2=\"246\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"8\" y=\"146\" width=\"92\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"54\" y=\"171.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Placebo\u003c/text>\u003crect x=\"104\" y=\"146\" width=\"92\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"171.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">320 mg\u003c/text>\u003crect x=\"200\" y=\"146\" width=\"92\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"246\" y=\"171.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">640 mg\u003c/text>\u003cline x1=\"54\" y1=\"186\" x2=\"54\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"150\" y1=\"186\" x2=\"150\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"246\" y1=\"186\" x2=\"246\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"54\" y1=\"208\" x2=\"246\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"150\" y1=\"208\" x2=\"150\" y2=\"224\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"30\" y=\"226\" width=\"240\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"245.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"9.5\" font-weight=\"700\" letter-spacing=\"0.5\" fill=\"#3a5a00\">ASSESSED AT\u003c/text>\u003ctext x=\"150\" y=\"260\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Baseline  ·  ~2 hours\u003c/text>\u003cline x1=\"150\" y1=\"270\" x2=\"150\" y2=\"290\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"62\" y=\"292\" width=\"176\" height=\"38\" rx=\"9\" fill=\"#c8f24e\"/>\u003ctext x=\"150\" y=\"317.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#0e0f13\">Single dose\u003c/text>\u003c/svg>","type":"trial"},{"n":"Trial 6","t":"Calm focus from a single dose","cite":"Benson et al., 2014","cred":"17 adults · single dose · 320/640 mg","sold":"KeenMind","status":"primary","src":"Acute effects of Bacopa monnieri (CDRI-08) on multitasking, stress and mood · Phytotherapy Research 2014;28(4):551–559","design":["Randomised","Double-blind","Crossover","Single dose","320 / 640 mg"],"meas":["Cortisol (stress hormone)","Alertness & mood","Multitasking performance"],"find":"Reduced cortisol at 640 mg (p=.018/.022) and improved alertness at 320 mg (p=.001). The overall multitasking score showed no differential effect, so scope to cortisol and alertness.","note":"","pub":"https://pubmed.ncbi.nlm.nih.gov/23788517/","drive":"Swinburne Research bacopa.pdf (primary held; filename is misleading)","dia":"\u003csvg viewBox=\"0 0 300 344\" width=\"100%\" role=\"img\" aria-label=\"Study design flow\">\u003cdefs>\u003cmarker id=\"ah\" markerWidth=\"8\" markerHeight=\"8\" refX=\"6\" refY=\"3\" orient=\"auto\">\u003cpath d=\"M0,0 L6,3 L0,6 Z\" fill=\"#c8f24e\"/>\u003c/marker>\u003c/defs>\u003crect x=\"85\" y=\"14\" width=\"130\" height=\"28\" rx=\"9\" fill=\"#e9ebe6\"/>\u003ctext x=\"150\" y=\"33.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Screening (Day 1)\u003c/text>\u003cline x1=\"150\" y1=\"42\" x2=\"150\" y2=\"64\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"40\" y=\"66\" width=\"220\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"87.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#14161a\">17 participants\u003c/text>\u003ctext x=\"150\" y=\"101.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"500\" letter-spacing=\"0\" fill=\"#4a4f55\">healthy adults · 18–44\u003c/text>\u003cline x1=\"150\" y1=\"110\" x2=\"150\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"54\" y1=\"132\" x2=\"246\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"54\" y1=\"132\" x2=\"54\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003cline x1=\"150\" y1=\"132\" x2=\"150\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003cline x1=\"246\" y1=\"132\" x2=\"246\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"8\" y=\"146\" width=\"92\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"54\" y=\"171.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Placebo\u003c/text>\u003crect x=\"104\" y=\"146\" width=\"92\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"171.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">320 mg\u003c/text>\u003crect x=\"200\" y=\"146\" width=\"92\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"246\" y=\"171.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">640 mg\u003c/text>\u003cline x1=\"54\" y1=\"186\" x2=\"54\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"150\" y1=\"186\" x2=\"150\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"246\" y1=\"186\" x2=\"246\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"54\" y1=\"208\" x2=\"246\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"150\" y1=\"208\" x2=\"150\" y2=\"224\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"30\" y=\"226\" width=\"240\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"245.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"9.5\" font-weight=\"700\" letter-spacing=\"0.5\" fill=\"#3a5a00\">ASSESSED AT\u003c/text>\u003ctext x=\"150\" y=\"260\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Baseline  ·  1 hour  ·  2 hours\u003c/text>\u003cline x1=\"150\" y1=\"270\" x2=\"150\" y2=\"290\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"62\" y=\"292\" width=\"176\" height=\"38\" rx=\"9\" fill=\"#c8f24e\"/>\u003ctext x=\"150\" y=\"317.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#0e0f13\">Single dose\u003c/text>\u003c/svg>","type":"trial"},{"n":"Trial 7","t":"Attention support in children","cite":"Negi et al., 2000","cred":"36 children · 12 weeks · ~100 mg/day","sold":"Memory Plus","status":"summary","src":"“Memory Plus” in children with ADHD symptoms · Indian J. Psychiatry 2000;42(2 suppl)","design":["Randomised","Double-blind","Placebo-controlled","12 weeks","~100 mg/day"],"meas":["Logical memory","Paired-associate learning","Attention","Hyperactivity"],"find":"Significant gains in logical memory (effect size 0.81), paired-associate learning and attention, which held after treatment stopped.","note":"“Memory Plus” is our CDRI extract under a different brand. The widely-quoted “67% improved concentration” is not in our source and is not used.","pub":"https://scholar.google.com/scholar?q=Negi+Bacopa+Memory+Plus+children+ADHD+2000","drive":"Summary via Kean 2016 review — obtain the primary","dia":"\u003csvg viewBox=\"0 0 300 344\" width=\"100%\" role=\"img\" aria-label=\"Study design flow\">\u003cdefs>\u003cmarker id=\"ah\" markerWidth=\"8\" markerHeight=\"8\" refX=\"6\" refY=\"3\" orient=\"auto\">\u003cpath d=\"M0,0 L6,3 L0,6 Z\" fill=\"#c8f24e\"/>\u003c/marker>\u003c/defs>\u003crect x=\"85\" y=\"14\" width=\"130\" height=\"28\" rx=\"9\" fill=\"#e9ebe6\"/>\u003ctext x=\"150\" y=\"33.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Screening (Day 1)\u003c/text>\u003cline x1=\"150\" y1=\"42\" x2=\"150\" y2=\"64\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"40\" y=\"66\" width=\"220\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"87.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#14161a\">36 children\u003c/text>\u003ctext x=\"150\" y=\"101.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"500\" letter-spacing=\"0\" fill=\"#4a4f55\">ages 6–12 · ADHD\u003c/text>\u003cline x1=\"150\" y1=\"110\" x2=\"150\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"220\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"80\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003cline x1=\"220\" y1=\"132\" x2=\"220\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"20\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"80\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Placebo (n=17)\u003c/text>\u003crect x=\"160\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"220\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Memory Plus (n=19)\u003c/text>\u003cline x1=\"80\" y1=\"186\" x2=\"80\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"220\" y1=\"186\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"208\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"150\" y1=\"208\" x2=\"150\" y2=\"224\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"30\" y=\"226\" width=\"240\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"245.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"9.5\" font-weight=\"700\" letter-spacing=\"0.5\" fill=\"#3a5a00\">ASSESSED AT\u003c/text>\u003ctext x=\"150\" y=\"260\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Baseline  ·  12 weeks\u003c/text>\u003cline x1=\"150\" y1=\"270\" x2=\"150\" y2=\"290\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"62\" y=\"292\" width=\"176\" height=\"38\" rx=\"9\" fill=\"#c8f24e\"/>\u003ctext x=\"150\" y=\"317.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#0e0f13\">~100 mg/day\u003c/text>\u003c/svg>","type":"trial"},{"n":"Trial 8","t":"Focus & flexibility in children","cite":"Kean et al., 2022","cred":"children 6–14 · 160/320 mg","sold":"CDRI-08","status":"obtain","src":"CDRI-08 in inattentive / hyperactive children 6–14 · Frontiers in Pharmacology 2022;13:878101","design":["Randomised","Double-blind","Placebo-controlled","14 weeks","160 / 320 mg"],"meas":["Cognitive flexibility (p=.01)","Executive function — CPRS (p=.04)"],"find":"Fewer errors and improved cognitive flexibility and executive functioning in children with inattention.","note":"","pub":"https://doi.org/10.3389/fphar.2022.878101","drive":"Not in Drive — our “Kean” file is his 2016 review; obtain the 2022 paper","dia":"\u003csvg viewBox=\"0 0 300 344\" width=\"100%\" role=\"img\" aria-label=\"Study design flow\">\u003cdefs>\u003cmarker id=\"ah\" markerWidth=\"8\" markerHeight=\"8\" refX=\"6\" refY=\"3\" orient=\"auto\">\u003cpath d=\"M0,0 L6,3 L0,6 Z\" fill=\"#c8f24e\"/>\u003c/marker>\u003c/defs>\u003crect x=\"85\" y=\"14\" width=\"130\" height=\"28\" rx=\"9\" fill=\"#e9ebe6\"/>\u003ctext x=\"150\" y=\"33.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Screening (Day 1)\u003c/text>\u003cline x1=\"150\" y1=\"42\" x2=\"150\" y2=\"64\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"40\" y=\"66\" width=\"220\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"87.75\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#14161a\">Children 6–14\u003c/text>\u003ctext x=\"150\" y=\"101.25\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"10.5\" font-weight=\"500\" letter-spacing=\"0\" fill=\"#4a4f55\">inattentive / hyperactive\u003c/text>\u003cline x1=\"150\" y1=\"110\" x2=\"150\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"220\" y2=\"132\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"132\" x2=\"80\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003cline x1=\"220\" y1=\"132\" x2=\"220\" y2=\"144\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"20\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"80\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Placebo\u003c/text>\u003crect x=\"160\" y=\"146\" width=\"120\" height=\"40\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"220\" y=\"172\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"12\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">CDRI-55\u003c/text>\u003cline x1=\"80\" y1=\"186\" x2=\"80\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"220\" y1=\"186\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"80\" y1=\"208\" x2=\"220\" y2=\"208\" stroke=\"#c8f24e\" stroke-width=\"2\"/>\u003cline x1=\"150\" y1=\"208\" x2=\"150\" y2=\"224\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"30\" y=\"226\" width=\"240\" height=\"44\" rx=\"9\" fill=\"#ffffff\"/>\u003ctext x=\"150\" y=\"245.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"9.5\" font-weight=\"700\" letter-spacing=\"0.5\" fill=\"#3a5a00\">ASSESSED AT\u003c/text>\u003ctext x=\"150\" y=\"260\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"11.5\" font-weight=\"700\" letter-spacing=\"0\" fill=\"#14161a\">Baseline  ·  Week 14\u003c/text>\u003cline x1=\"150\" y1=\"270\" x2=\"150\" y2=\"290\" stroke=\"#c8f24e\" stroke-width=\"2\" marker-end=\"url(#ah)\"/>\u003crect x=\"62\" y=\"292\" width=\"176\" height=\"38\" rx=\"9\" fill=\"#c8f24e\"/>\u003ctext x=\"150\" y=\"317.5\" text-anchor=\"middle\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"13\" font-weight=\"800\" letter-spacing=\"0\" fill=\"#0e0f13\">160 / 320 mg\u003c/text>\u003c/svg>","type":"trial"},{"n":"Mechanism","t":"How CDRI-55 works in the brain","cite":"Preclinical (lab) research","cred":"acetylcholine · serotonin · antioxidant","sold":"","status":"mech","src":"Shown in laboratory (animal / cell) studies — explains how it works, never a human result.","body":"In laboratory research the extract raises acetylcholine and serotonin signalling and strengthens antioxidant defences — the mechanisms believed to underlie the human results. Sources we hold: Charles 2011, Das 2002/2015, Bhattacharya 2000, Rajan 2011. Keep figures like “63% / 21%” out of headlines — they are preclinical and animal-derived.","dia":"\u003csvg viewBox=\"0 0 760 96\" width=\"100%\" role=\"img\" aria-label=\"Mechanism chain\">\u003cdefs>\u003cmarker id=\"am\" markerWidth=\"8\" markerHeight=\"8\" refX=\"6\" refY=\"3\" orient=\"auto\">\u003cpath d=\"M0,0 L6,3 L0,6 Z\" fill=\"#e0a92e\"/>\u003c/marker>\u003c/defs>\u003crect x=\"6\" y=\"30\" width=\"160\" height=\"40\" rx=\"9\" fill=\"#f3f4ef\"/>\u003ctext x=\"86\" y=\"55\" text-anchor=\"middle\" font-family=\"Arial\" font-size=\"11\" font-weight=\"700\" fill=\"#14161a\">Cholinergic ↑ (↓AChE)\u003c/text>\u003cline x1=\"166\" y1=\"50\" x2=\"196\" y2=\"50\" stroke=\"#e0a92e\" stroke-width=\"2\" marker-end=\"url(#am)\"/>\u003crect x=\"196\" y=\"30\" width=\"160\" height=\"40\" rx=\"9\" fill=\"#f3f4ef\"/>\u003ctext x=\"276\" y=\"55\" text-anchor=\"middle\" font-family=\"Arial\" font-size=\"11\" font-weight=\"700\" fill=\"#14161a\">Serotonergic (TPH2·SERT)\u003c/text>\u003cline x1=\"356\" y1=\"50\" x2=\"386\" y2=\"50\" stroke=\"#e0a92e\" stroke-width=\"2\" marker-end=\"url(#am)\"/>\u003crect x=\"386\" y=\"30\" width=\"160\" height=\"40\" rx=\"9\" fill=\"#f3f4ef\"/>\u003ctext x=\"466\" y=\"55\" text-anchor=\"middle\" font-family=\"Arial\" font-size=\"11\" font-weight=\"700\" fill=\"#14161a\">Antioxidant (↑SOD·CAT·GPx)\u003c/text>\u003cline x1=\"546\" y1=\"50\" x2=\"576\" y2=\"50\" stroke=\"#e0a92e\" stroke-width=\"2\" marker-end=\"url(#am)\"/>\u003crect x=\"576\" y=\"30\" width=\"160\" height=\"40\" rx=\"9\" fill=\"#f3f4ef\"/>\u003ctext x=\"656\" y=\"55\" text-anchor=\"middle\" font-family=\"Arial\" font-size=\"11\" font-weight=\"700\" fill=\"#14161a\">Neuroprotection (↑BDNF)\u003c/text>\u003c/svg>","type":"mech"}];
const wall=document.getElementById('wall');
wall.innerHTML=DATA.map(function(d,i){return renderTile(d,i);}).join('');
function renderTile(d,i){return '<div class="tile" tabindex="0" role="button" data-i="'+i+'" aria-label="Open '+d.cite+'"><div class="top"><span class="bn '+(d.type==='mech'?'mech':'')+'">'+d.n+'</span><span class="dot '+d.status+'"></span></div><h3>'+d.t+'</h3><div class="ci">'+(d.type==='mech'?'Preclinical':d.cite)+'</div><div class="cr">'+d.cred+'</div><div class="go">View study design ↗</div></div>';}
const mask=document.getElementById('mask'),mcard=document.getElementById('mcard');
function open(i){const d=DATA[i];let h='<button class="mx" id="mx" aria-label="Close">✕</button>';
 h+='<div class="mbar"><span class="bn '+(d.type==='mech'?'mech':'')+'">'+d.n+'</span><h2>'+d.t+'</h2><span class="ci">'+(d.type==='mech'?'Preclinical':d.cite)+'</span></div>';
 h+='<div class="msrc">'+d.src+'</div>';
 if(d.type==='mech'){h+='<div class="mflow">'+d.dia+'</div><div class="mfind">'+d.body+'</div>';}
 else{h+='<div class="mpills"><span class="pill ours">Extract: CDRI-08 / CDRI-55</span><span class="pill sold">Sold as: '+d.sold+'</span><span class="pill '+d.status+'">'+({primary:'Primary paper held',summary:'Summary — obtain primary',obtain:'Paper to obtain'}[d.status])+'</span></div>';
  h+='<div class="mgrid"><aside class="mside"><h4>Study design</h4><ul>'+d.design.map(x=>'<li>'+x+'</li>').join('')+'</ul></aside><div class="mflow">'+d.dia+'</div><aside class="mside"><h4>What was measured</h4><ul>'+d.meas.map(x=>'<li>'+x+'</li>').join('')+'</ul></aside></div>';
  h+='<div class="mfind"><b>Key finding.</b> '+d.find+'</div>';
  if(d.note)h+='<div class="mnote">'+d.note+'</div>';
  h+='<div class="mtrace"><span><span class="l">Published source:</span> <a href="'+d.pub+'" target="_blank" rel="noopener">open paper ↗</a></span><span><span class="l">Our Drive file:</span> '+d.drive+'</span></div>';}
 mcard.innerHTML=h;mask.classList.add('on');document.getElementById('mx').onclick=close;}
function close(){mask.classList.remove('on');}
wall.addEventListener('click',e=>{const t=e.target.closest('.tile');if(t)open(+t.dataset.i);});
wall.addEventListener('keydown',e=>{if((e.key==='Enter'||e.key===' ')&&e.target.closest('.tile')){e.preventDefault();open(+e.target.closest('.tile').dataset.i);}});
mask.addEventListener('click',e=>{if(e.target===mask)close();});
document.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
})();


});

